function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTwitter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 318"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Icon awesome-twitter",
    d: "M21.532 8.238c.015.213.015.426.015.64A13.9 13.9 0 0 1 7.553 22.873 13.9 13.9 0 0 1 0 20.665a10.174 10.174 0 0 0 1.188.061 9.851 9.851 0 0 0 6.106-2.1 4.927 4.927 0 0 1-4.6-3.411 6.2 6.2 0 0 0 .929.076 5.2 5.2 0 0 0 1.294-.167 4.919 4.919 0 0 1-3.942-4.83v-.061a4.954 4.954 0 0 0 2.223.624 4.926 4.926 0 0 1-1.523-6.578 13.981 13.981 0 0 0 10.142 5.147A5.553 5.553 0 0 1 11.7 8.3a4.923 4.923 0 0 1 8.512-3.365 9.684 9.684 0 0 0 3.122-1.188 4.905 4.905 0 0 1-2.162 2.711A9.86 9.86 0 0 0 24 5.7a10.573 10.573 0 0 1-2.467 2.543z",
    transform: "translate(.001 -1.127)",
    style: {
      fill: "#7a8b99"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitter);
export default __webpack_public_path__ + "static/media/twitter.b44043ad902112d96da33fe75ef3a993.svg";
export { ForwardRef as ReactComponent };